import { replaceMakeModelPlaceholders } from "./replaceMakeModelPlaceholders";

const DYNAMIC_TEXT_MAX_LENGTH = 23;

const getMakeModelButtonText = (template: string, make: string, model: string) => {
  if (!template || (!make && !model)) return "";

  if (make && model) {
    const full = replaceMakeModelPlaceholders(template, { make, model });
    if (full.length <= DYNAMIC_TEXT_MAX_LENGTH) return full;
  }

  if (make) {
    const makeOnly = replaceMakeModelPlaceholders(template, { make, model: "" }).trim();
    if (makeOnly.length <= DYNAMIC_TEXT_MAX_LENGTH) return makeOnly;
  }

  if (model) {
    const modelOnly = replaceMakeModelPlaceholders(template, { make: "", model }).trim();
    if (modelOnly.length <= DYNAMIC_TEXT_MAX_LENGTH) return modelOnly;
  }

  return "";
};

export default getMakeModelButtonText;
